import { gsap } from "gsap";

const pageHeaderMediaGrid = document.querySelector(".page-header-media-grid");

const timeline = gsap.timeline({ repeat: pageHeaderMediaGrid.classList.contains("as-static") ? 0 : -1, delay: 1 });
timeline.addLabel("start");

pageHeaderMediaGrid.querySelectorAll(".media-grid-item").forEach((item, groupIndex) => {
  const children = item.children;
  const hasMultiple = children.length > 1;
  const groupTimeline = gsap.timeline({ repeat: hasMultiple ? -1 : 0, delay: groupIndex * 0.2 });

  if (hasMultiple) {
    for (let i = 0; i < children.length; i++) {
      groupTimeline
        .to(children[i], { duration: 1, opacity: 1, scale: 1, zIndex: 10 })
        .to(children[i], { duration: 0.6, opacity: 0, scale: 0.75, zIndex: 0 }, "+=5");
    }
  } else {
    groupTimeline.to(children[0], { duration: 1, opacity: 1, scale: 1, zIndex: 10 });
  }

  timeline.add(groupTimeline, "start");
});
